(function ($) {

  var qtyfield = '';
  // Private plugin variables
  var $formContainer, $addToCart, $cartCountSelector, $cartCostSelector, $cartContainer, $drawerContainer;

  $addToCart = $('.add-to-cart');

  $(document).ready(function () {
    addToCart();
    getCart(cartUpdateCallback);
  });

  $(window).on('load resize', function () {
    if(isMobileDevice()){
      var loop = setInterval(updateCartQty(), 500);
      // some time later clear the interval
      clearInterval(loop);
    }
  });
  
  //Update cart quantity on + or - button click (minicart)
  $(document).on("click", '.cart-qty-step', function(event) {
    	lineItemId = $(this).closest('.item').data('itemid');
    	quantityBox = $(this).closest('.qty-changer').find('.custom-quantity-input-cart');
    	currentQuantity = parseInt(quantityBox.val());
        if ($(this).hasClass('step-decrease')) {
        	quantityBox.val(currentQuantity - 1);
        } else {
        	quantityBox.val(currentQuantity + 1);
        }
      	changeItemQuantity(lineItemId, quantityBox.val());
  });
  
  //Update cart quantity with input field (minicart)
  $(document).on("blur", '.custom-quantity-input-cart', function(event) {
    	lineItemId = $(this).closest('.item').data('itemid');
    	quantityBox = parseInt($(this).val());
        if(Math.floor(quantityBox) == quantityBox && $.isNumeric(quantityBox)) {
        	changeItemQuantity(lineItemId, quantityBox);
        } else {
          	$(this).val(1);
        	changeItemQuantity(lineItemId, 1);
        }
  });
  
  //Remove item from cart (minicart)
  $(document).on("click", '.remove-line', function(event) {
    	lineItemId = $(this).closest('.item').data('itemid');
      	changeItemQuantity(lineItemId, 0);
  });
  
  //Show panel (Compatible Accessories)
  $(document).on("click", '#compatible-products-button', function(e) {
    	e.preventDefault();
    	$('#compatible-accessories').css('right', '0px');
  });
  
  //Hide panel (Compatible Accessories)
  $(document).on("click", '#close-accessories', function(e) {
    	e.preventDefault();
    	$('#compatible-accessories').css('right', '-' + $('#compatible-accessories').width() + 'px');
  });
  
  //Close mobile cart popup
  $(document).on("click", '#mobile-cart-popup .cart-close, #mobile-cart-popup .keep-shopping', function(e) {
    	e.preventDefault();
    	$('#mobile-cart-popup').slideUp();
  });
  
  //Update cart quantity on + or - button click (Compatible Accessories)
  $(document).on("click", '.accessories-qty-step', function(e) {
    	//lineItemId = $(this).closest('.item').data('itemid');
    	quantityBox = $(this).closest('.qty-changer').find('.accessories-quantity-input-cart');
    	currentQuantity = parseInt(quantityBox.val());
        if ($(this).hasClass('step-decrease')) {
          	newquantity = currentQuantity - 1;
        } else {
        	newquantity = currentQuantity + 1;
        }
    	quantityBox.val(newquantity);
    	if (newquantity > 0) {
        	$(this).closest('.qty-changer').find('.step-decrease').prop('disabled', false);
        } else {
        	$(this).closest('.qty-changer').find('.step-decrease').prop('disabled', true);
        }
      	//changeItemQuantity(lineItemId, quantityBox.val());
    	updateAccessoriesTotal();
    	e.preventDefault();
  });
  
  //Add selected compatible accessories to the cart
  $(document).on("click", '#add-accessories-cart', function(e) {
    	var productArray = [];
    	var quantityArray = [];
    	$('.order-buttons').each(function(index, element){
          itemQty = Number($(element).find('.accessories-quantity-input-cart').val());
          if (itemQty > 0) {
            variantId = $(element).find('.accessories-quantity-input-cart').data('variantid');
            productArray.push(variantId);
            quantityArray.push(itemQty);
          }
        });
    	
        addAllItems(productArray, quantityArray);
    	e.preventDefault();
  });
  
  function addAllItems(prodArray, quantArray){
	Shopify.queue = [];
	  var quantity = 1 ;
	  for (var i = 0; i < prodArray.length; i++) {
	    product = prodArray[i];
        qty = quantArray[i];
	    Shopify.queue.push({
	      variantId: product,
          quantity: qty,
	    });
          }
	  Shopify.moveAlong = function() {
	  // If we still have requests in the queue, let's process the next one.
	  if (Shopify.queue.length) {
	    var request = Shopify.queue.shift();
        var data = 'id='+ request.variantId + '&quantity=' + request.quantity
	    $.ajax({
	      type: 'POST',
          url: '/cart/add.js',
	      dataType: 'json',
	      data: data,
	      success: function(res){
            getCart(cartUpdateCallback);
	        Shopify.moveAlong();
	     },
             error: function(){
	     // if it's not last one Move Along else update the cart number with the current quantity
		  if (Shopify.queue.length){
		    Shopify.moveAlong()
		  } else {
		    //$('#cart-number').replaceWith("<a href="/cart" id="cart-number">View cart (" + quantity + ")</a>")
		  }
	      }
           });
        }
	 // If the queue is empty, we add 1 to cart
	else {
	  //Reset the product forms
      $('.accessories-quantity-input-cart').val(0);
      $('.accessories-qty-step.step-decrease').prop('disabled', true);
      $('#add-accessories-cart').prop('disabled', true);
      $('#compatible-accessories').css('right', '-' + $('#compatible-accessories').width() + 'px');
      setTimeout(flashTheCart, 1000);
	 }
       };
    Shopify.moveAlong();
  };
  
  function updateAccessoriesTotal() {
    accessoriesTotal = 0;
    $('.compatible-accessories-item').each(function(index, element){
      itemPrice = Number($(element).find('.price').data('price'));
      itemQty = Number($(element).find('.accessories-quantity-input-cart').val());
      accessoriesTotal = accessoriesTotal + (itemPrice * itemQty);
    });
    $('#compatible-accessories .addons-price').text('$' + accessoriesTotal.toFixed(2));
    if (accessoriesTotal > 0) {
    	$('#add-accessories-cart').prop('disabled', false);
    } else {
    	$('#add-accessories-cart').prop('disabled', true);
    }
  }
  
  
  function isMobileDevice() {
    return (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1);
  };

  function updateCartQty(){
    
    if(!qtyfield){
      qtyfield = $('.item-qty').find('input[name="updates[]"]').clone();
      $('input[name="updates[]"]').remove();
    }
    if(isMobileDevice()){
      
      var qty = $('.mobile-qty-button');
      
      for (i = 0; i < $(qtyfield).length; i++) { 
        
        var quantField = $(qtyfield[i])
        var mobileQuantButton = $(qty[i])
        
        $(quantField).insertAfter(mobileQuantButton);
      }
    }
  }
  
//   old function 
//   function updateCartQty(){
//     if(!qtyfield){
//       qtyfield = $('.item-qty').find('input[name="updates[]"]').clone();
//       $('input[name="updates[]"]').remove();
//     }
//     if($(window).innerWidth() <= 767){
//       $(qtyfield).insertAfter('.mobile-qty-button');
//     }else{
//       $(qtyfield).insertAfter('.qty-button');
//     }
//   }

  lastClick = 0;
  function displayCartCount(cart){
    var $cart_icon = $('.header-cart-hover-button'); 
    $('.header-cart-hover-button').find('.cart-item-amount').text(cart.item_count);

	var delay = 100;


  }

  
//   function displayCartCount(cart){
//     var $cart_icon = $('#cart_icon'); 
//     $cart_icon.find('.count').text(cart.item_count);

//     $cart_icon.click(function(e){
//       e.preventDefault();
//       var $header_cart = $('#header-cart');
//       if($header_cart.hasClass('open')){
//         $header_cart.removeClass('open');
//         $header_cart.hide();
//       }else{
//         $header_cart.addClass('open');
//         $header_cart.show();
//       }
//     });
//   }

  function addToCart(){
    $addToCart.click(function(e){
      e.preventDefault();
      var form = $(this).parents('form');
      addItemFromForm(form, getCart, itemErrorCallback);
    });
  }

  function addItemFromForm (form, callback, errorCallback) {
    var params = {
      type: 'POST',
      url: '/cart/add.js',
      data: $(form).serialize(),
      dataType: 'json',
      success: function(line_item) {
        if ((typeof callback) === 'function') {
          callback(cartUpdateCallback);
        }
        else {
          ShopifyAPI.onItemAdded(line_item, form);
        }
        //Flash up the mini cart when product added to cart
        flashTheCart();
        
        if (CorraUI.checkMediaQuery(900)) {
          	$('#mobile-cart-popup .mobile-product-name').text(line_item['title']);
        	$('#mobile-cart-popup').slideDown();
        }
        
      },
      error: function(XMLHttpRequest, textStatus) {
        $('.product-view').find('.errors').remove();
        if ((typeof errorCallback) === 'function') {
          errorCallback(XMLHttpRequest, textStatus);
        }
        else {
          ShopifyAPI.onError(XMLHttpRequest, textStatus);
        }
      }
    };
    jQuery.ajax(params);
  };
  
  function flashTheCart() {
  	if (!CorraUI.checkMediaQuery(900)) {
      $('.header-cart-hover-button #header-cart')
      .css('max-height', '700px')
      .delay(3000)
      .queue(function (next) { 
        $(this).css('max-height', ''); 
        next(); 
      });
    } else {
      $('.header-cart-hover-button')
      .css('background', '#505050')
      .delay(2000)
      .queue(function (next) { 
        $(this).css('background', ''); 
        next(); 
      });
    }
  }
  
  function changeItemQuantity (itemId, newQuantity) {
    var params = {
      	global: false,
    	type: 'POST',
        url: '/cart/change.js',
        data: { quantity: newQuantity, id: itemId },
        dataType: 'json',
      	beforeSend:function(){
                     $("#minicart-ajax-loader").show();
                   },
      	success: function() { getCart(cartUpdateCallback); $("#minicart-ajax-loader").fadeOut(); }
    };
    jQuery.ajax(params);
  };

  // Get from cart.js returns the cart in JSON
  function getCart(callback) {
    jQuery.getJSON('/cart.js', function (cart, textStatus) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
    });
  };

  function cartUpdateCallback(cart) {
    buildCart(cart);
    displayCartCount(cart);
  };

  function buildCart(cart) {
    $cartContainer = $('#header-cart');
    // Start with a fresh cart div
    $cartContainer.find('#cart-sidebar').empty();
	giftCardsTotal = 0;
    // Show empty cart
    if (cart.item_count === 0) {
      $('.cart_content').hide();
      $cartContainer
      .find('.minicart-wrapper')
      .append('<p class="empty">You have no items in your shopping cart.</p>');
      $('#cart_icon').addClass('no-count');
      return;
    }

    // Handlebars.js cart layout
    var items = [],
        item = {},
        data = {};

    // Add each item to our handlebars.js data
    $.each(cart.items, function(index, cartItem) {

      if (cartItem.image != null){
        var prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_small$1").replace('http:', '');
      } else {
        var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
      }
		//console.log(cartItem);
      if (cartItem.properties !== null) {
        $.each(cartItem.properties, function(key, value) {
          if (key.charAt(0) === '_' || !value) {
            delete cartItem.properties[key];
          }
        });
      }
      
      if (cartItem.product_title == "Gift Card") {
        cartPrice = cartItem.price;
        giftCardsTotal = giftCardsTotal + cartItem.price;
      } else {
        cartPrice = cartItem.price * 1.1;
      }

       var template = '<li class="item" data-itemid="'+cartItem.id+'">' +
          '<a href="'+cartItem.url+'" title="" class="product-image">' +
          '<img src="'+ prodImg +'" width="50" height="50" alt="">' +
          '</a>' +
          '<div class="product-details">' +
          '<p class="product-name"><a href="'+cartItem.url+'">'+cartItem.product_title+'</a></p>';
      if(cartItem.variant_title){
        template +='<p>' +
          '<span class="item-options">'+cartItem.variant_title+'</span>'+
          '</p>';
      }
          template += '<p>' +
          '<span class="price"> '+ theme.Currency.formatMoney(cartPrice) +'</span>   ' +                                                     
          '</p>' +
          '<span class="qty">QTY: '+cartItem.quantity+'</span>' +
          '</div>'+
          '<div class="qty-changer">';
      if(cartItem.quantity <= 1 ){
      	template +='<button class="cart-qty-step step-decrease" disabled=""></button>';
      } else {
      	template +='<button class="cart-qty-step step-decrease"></button>';
      }
        template +='<input type="number" class="custom-quantity-input-cart" value="'+cartItem.quantity+'" min="1" max="99">'+
          '<button class="cart-qty-step step-increase"></button>'+
          '</div>'+
          '<div class="line-total">'+
          '<span>'+(theme.Currency.formatMoney(cartPrice*cartItem.quantity))+'</span>'+
          '<a class="remove-line" href="#">Remove</a>'+
          '</div>'+
          '</li>';
      
      $cartContainer.find('#cart-sidebar').append(template);
    });

    $('#cart_icon').removeClass('no-count');
    $('.cart_content').show();
    $cartContainer.find('.minicart-wrapper').find('.empty').remove();
    $cartContainer.find('.subtotal').find('.price').text(theme.Currency.formatMoney( ((cart.original_total_price - giftCardsTotal)  * 1.1) + giftCardsTotal));
  }

  function itemErrorCallback(XMLHttpRequest, textStatus) {
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    $addToCart.removeClass('is-adding is-added');

    if (!!data.message) {
      if (data.status == 422) {
        $('form').after('<div class="errors qty-error">'+ data.description +'</div>')
      }
    }
  };
})(jQuery);